import React, { memo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useFontStyle } from "~/hook/useFontStyle";
import useLocale from "~/hook/useLocale";
import { LiveData } from "~/interface/home/home";
import { cn } from "~/lib/utils";
import { LANG, LIVE_TV } from "~/utils/constant";
import LiveDataCard from "./LiveDataCard";
import LiveTvRadioCarousel from "./LiveTvRadioCarousel";
import { useLanguageParams } from "~/hook/useLanguageParams";

interface LiveTvRadioProps {
  data: LiveData[];
}

const LiveTvRadio = memo(function LiveTvRadio({ data }: LiveTvRadioProps) {
  const [selectedTab, setSelectedTab] = useState(LIVE_TV);
  const { medium, normalInter } = useFontStyle();
  const { t } = useTranslation();
  const { navigate, LocalizedLink } = useLocale();
  const handleOnTVClick = (type: string) => {
    const PATH = `/live/${type.split("_").join("-")}`;
    navigate(PATH);
  };

  const lang = useLanguageParams();
  const isGujarati = lang === LANG.gujarati;

  return (
    // gap-1 md:
    <div className="w-full flex flex-col justify-start items-center gap-btw-text-and-content">
      <div className="w-full flex flex-col justify-center items-center gap_btw_title_content md:px-0">
        <LocalizedLink to={"/live"} className={cn(isGujarati ? "home-page-heading-mar-guj" : "home-page-heading", medium)}>
          {t("home.experienceLiveTvRadio")}
        </LocalizedLink>

        <span className={cn("sub_desc_text_color body_text_l text-center title_para_width ", normalInter)}>
          {t("home.liveDescription", {
            defaultValue: "24/7 Spiritual Streaming: Immerse yourself in Katha, Kirtan, and Dhun with our live TV and Radio channels.",
          })}
        </span>
      </div>

      <div className={cn("hidden w-full lg:grid gap-4  ", `${data?.length ? `md:grid-cols-${data?.length || 5}` : `md:grid-cols-5`}`)}>
        {data.map((data) => (
          <React.Fragment key={data.id}>
            <LiveDataCard data={data} selectedTab={selectedTab} handleOnTVClick={handleOnTVClick} />
          </React.Fragment>
        ))}
      </div>

      <div className="w-full flex justify-center items-center lg:hidden">
        <LiveTvRadioCarousel data={data} selectedTab={selectedTab} handleOnTVClick={handleOnTVClick} />
      </div>
    </div>
  );
});

export default LiveTvRadio;
